import { FooterController, HeaderController, MtLayoutController } from '@application/components';
import { MY_TIPAW_ROUTES } from '@application/constants';
import { useRouter } from '@application/utils';
import { useTipawStore } from '@application/api';
import { SocialsSideButtons } from '@presentation/components';
import type { FC, ReactNode } from 'react';
import * as Styled from './styled';

export const LayoutWrapper: FC<{ children: ReactNode }> = (props) => {
  const { children } = props;
  const { infoFromCurrentPath } = useRouter();
  const { showStickyBanner } = useTipawStore();

  if (MY_TIPAW_ROUTES.includes(infoFromCurrentPath.route)) {
    return <MtLayoutController>{children}</MtLayoutController>;
  }

  return (
    <Styled.Root id="layout-wrapper" showStickyBanner={showStickyBanner}>
      <HeaderController />
      <SocialsSideButtons />
      {children}
      <FooterController />
    </Styled.Root>
  );
};
